/**
 * Single source of truth for rendering a numeric value with the viewer's
 * default-locale digit grouping (thousands separators).
 *
 * This is intentionally byte-equivalent to the bare `n.toLocaleString()` calls
 * it replaces (default runtime locale, default options). It exists so that a
 * future locale/grouping decision propagates to every count display at once
 * (credits balance, animated stat counters, big-number blocks, gate maths)
 * instead of being re-decided site by site.
 *
 * NOTE: currency rendering lives in `@/lib/pricing` (`formatCurrency`), the one
 * money formatter — 2 decimals, i18n runtime locale, and an EXPLICIT
 * minor/major unit. Number grouping (this file) stays separate on purpose.
 */
export function formatNumber(value: number): string {
  return value.toLocaleString();
}
